import React from 'react'
import { twMerge } from 'tailwind-merge'
import { AnimatePresence, motion } from 'framer-motion'
import { vibrateMobileIfPresent } from '@/utils/vibrateUtils'

type Props = {
  checked: boolean
  onChange?: () => void
  className?: string
  customClasses?: {
    outerCircle?: string
    innerCircle?: string
    selectedCircle?: string
  }
}

export default function RadioButton(props: Props) {
  const onChange = () => {
    vibrateMobileIfPresent('impactHeavy')
    props.onChange?.()
  }

  return (
    <label
      className={twMerge(
        'flex items-center gap-2 cursor-pointer',
        props.className,
      )}
    >
      <input
        type="radio"
        checked={props.checked}
        onChange={onChange}
        className="sr-only peer"
        name="program"
      />
      <motion.div
        whileTap={{ scale: 0.8 }}
        transition={{ type: 'spring', stiffness: 400, damping: 20 }}
        className="flex items-center justify-center"
      >
        <div className="relative w-5 h-5">
          {/* Outer circle */}
          <motion.div
            className={twMerge(
              'w-5 h-5 rounded-full border-2 bg-base-blue-500 border-base-blue-500',
              props.customClasses?.outerCircle,
            )}
            transition={{ duration: 0.15 }}
          />

          {/* Inner ring */}
          <div
            className={twMerge(
              'absolute top-0.5 left-0.5 w-4 h-4 rounded-full bg-white',
              props.customClasses?.innerCircle,
            )}
          />

          {/* Selected dot */}
          <AnimatePresence>
            {props.checked && (
              <motion.div
                className={twMerge(
                  'absolute top-1 left-1 w-3 h-3 rounded-full bg-base-blue-500',
                  props.customClasses?.selectedCircle,
                )}
                initial={{ scale: 0, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                exit={{ scale: 0.5, opacity: 0 }}
                transition={{ type: 'spring', stiffness: 300, damping: 20 }}
              />
            )}
          </AnimatePresence>
        </div>
      </motion.div>
    </label>
  )
}
